import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  "motivated",
  "confident",
  "nervous",
  "frustrated",
  "unmotivated",
  "notSure",
] as const

export default function HowFeeling() {
  return <SingleSelectPage translationKey="howFeeling" options={OPTIONS} />
}
